import { render, staticRenderFns } from "./Bussiness.vue?vue&type=template&id=5de27865&"
import script from "./Bussiness.vue?vue&type=script&lang=js&"
export * from "./Bussiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Bussiness.vue"
export default component.exports